import { Brain } from 'lucide-react';

import { NodeShell } from './NodeShell';

export const RunReviewNode = ({
  data,
  selected,
}: {
  data: { label: string; outputKey?: string };
  selected?: boolean;
}) => (
  <NodeShell
    type="run_review"
    icon={<Brain size={16} />}
    label={data.label}
    subtitle={data.outputKey ? `→ ${data.outputKey}` : undefined}
    selected={selected}
  />
);
